package com.tovtalk.data.mapper

import com.tovtalk.domain.entity.ChatThread
import com.tovtalk.domain.entity.ChatType
import com.tovtalk.domain.entity.Message
import com.tovtalk.domain.entity.User
import kotlin.time.Instant

object ChatMapperJs {
    /**
     * Build ChatThread from Firestore thread doc (id = otherUserId, data with lastMessage, unreadCount, chatType, updatedAt).
     * conversationId should be getConversationId(currentUserId, otherUserId).
     */
    fun mapToChatThread(
        docId: String,
        data: dynamic,
        otherUser: User,
        conversationId: String
    ): ChatThread {
        val lastMessageData = js("(function(d){ return d && d.lastMessage; })").unsafeCast<(dynamic) -> dynamic>()(data)
        val lastMessage = if (lastMessageData != null) {
            ChatMapperJs.mapToMessage(lastMessageData, "last")
        } else null
        val unreadCount = js("(function(d){ return d && d.unreadCount != null ? Number(d.unreadCount) : 0; })").unsafeCast<(dynamic) -> Int>()(data)
        val chatTypeStr = js("(function(d){ return d && d.chatType ? d.chatType : 'requested'; })").unsafeCast<(dynamic) -> String>()(data)
        val isDeleted = js("(function(d){ return !!(d && d.isDeleted); })").unsafeCast<(dynamic) -> Boolean>()(data)
        val updatedAtMs = js("(function(d){ if(!d || !d.updatedAt) return 0; var t = d.updatedAt; return typeof t.toMillis === 'function' ? t.toMillis() : 0; })").unsafeCast<(dynamic) -> Double>()(data)
        val updatedAt = Instant.fromEpochMilliseconds(updatedAtMs.toLong())
        return ChatThread(
            conversationId = conversationId,
            otherUser = otherUser,
            lastMessage = lastMessage,
            unreadCount = unreadCount,
            chatType = ChatType.fromString(chatTypeStr),
            isDeleted = isDeleted,
            updatedAt = updatedAt
        )
    }
    /**
     * Map Firestore document (from snapshot.doc.data() or plain map) to Message.
     * createdAt/receivedAt/readAt may be Firestore Timestamp with toMillis().
     */
    fun mapToMessage(data: dynamic, messageId: String): Message {
        fun tsToInstant(ts: dynamic): Instant? {
            val ms = js("(function(ts){ return ts != null && typeof ts.toMillis === 'function' ? ts.toMillis() : null; })").unsafeCast<(dynamic) -> Double?>()(ts)
            return ms?.toLong()?.let { Instant.fromEpochMilliseconds(it) }
        }
        val senderId = (data?.senderId as? Number)?.toInt() ?: 0
        val receiverId = (data?.receiverId as? Number)?.toInt() ?: 0
        return Message(
            id = messageId,
            conversationId = data?.conversationId as? String ?: "",
            senderId = senderId,
            receiverId = receiverId,
            content = data?.content as? String,
            isDeleted = data?.isDeleted as? Boolean ?: false,
            createdAt = tsToInstant(data?.createdAt) ?: Instant.fromEpochMilliseconds(0),
            receivedAt = tsToInstant(data?.receivedAt),
            readAt = tsToInstant(data?.readAt)
        )
    }
}
